/** @module users/store/mutations */

export default {
  SET_USER: (state, user = null) => { state.current = user },
  SET_USER_MICROLOANS: (state, data = null) => { state.microloans = data },
}
